// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_tdx","cls2":"SimplePaperPodcast-cls2_gbP SimplePaperPodcast-cls1_tdx"};